"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionCollapse = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var react_animate_height_1 = __importDefault(require("react-animate-height"));
var AccordionCollapse = /** @class */ (function (_super) {
    __extends(AccordionCollapse, _super);
    function AccordionCollapse(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function () {
            clearTimeout(_this.timeout);
            if (!_this.containerRef || !_this.contentRef) {
                return;
            }
            var isOpen = _this.props.isOpen;
            var containerHeight = _this.containerRef.current.clientHeight;
            var contentHeight = _this.contentRef
                .current.clientHeight;
            var isFullOpen = isOpen && contentHeight === containerHeight;
            var isFullClosed = !isOpen && containerHeight === 0;
            if (isFullOpen || isFullClosed) {
                _this.onRest({
                    isFullOpen: isFullOpen,
                    isFullClosed: isFullClosed,
                    isOpen: isOpen,
                    containerHeight: containerHeight,
                    contentHeight: contentHeight
                });
            }
            else {
                _this.onWork({
                    isFullOpen: isFullOpen,
                    isFullClosed: isFullClosed,
                    isOpen: isOpen,
                    containerHeight: containerHeight,
                    contentHeight: contentHeight
                });
                _this.timeout = setTimeout(function () { return _this.onResize(); }, 50);
            }
        };
        _this.onRest = function (_a) {
            var isFullOpen = _a.isFullOpen, isFullClosed = _a.isFullClosed, isOpen = _a.isOpen, containerHeight = _a.containerHeight, contentHeight = _a.contentHeight;
            if (!_this.containerRef || !_this.contentRef) {
                return;
            }
            var opened = isOpen && _this.containerRef.current.style.height === "".concat(contentHeight, "px");
            var closed = !isOpen && _this.containerRef.current.style.height === "0px";
            if (opened || closed) {
                _this.containerRef.current.style.height = isOpen ? "auto" : "0px";
            }
        };
        _this.onWork = function (_a) {
            var isFullOpen = _a.isFullOpen, isFullClosed = _a.isFullClosed, isOpen = _a.isOpen, containerHeight = _a.containerHeight, contentHeight = _a.contentHeight;
            if (!_this.containerRef || !_this.contentRef) {
                return;
            }
            var opened = isOpen && _this.containerRef.current.style.height === "".concat(contentHeight, "px");
            var closed = !isOpen && _this.containerRef.current.style.height === "0px";
            if (opened || closed) {
                return;
            }
            _this.containerRef.current.style.height = isOpen
                ? "".concat(contentHeight, "px")
                : "0px";
        };
        _this.containerRef = React.createRef();
        _this.contentRef = React.createRef();
        return _this;
    }
    AccordionCollapse.prototype.componentDidMount = function () {
        this.onResize();
    };
    AccordionCollapse.prototype.componentDidUpdate = function () {
        this.onResize();
    };
    AccordionCollapse.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeout);
    };
    AccordionCollapse.prototype.getSnapshotBeforeUpdate = function () {
        if (!this.containerRef || !this.contentRef) {
            return null;
        }
        if (this.containerRef.current.style.height === "auto") {
            var contentHeight = this.contentRef
                .current.clientHeight;
            this.containerRef.current.style.height = "".concat(contentHeight, "px");
        }
        return null;
    };
    AccordionCollapse.prototype.render = function () {
        var _a = this.props, children = _a.children, isOpen = _a.isOpen;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: this.containerRef, className: "accordion-item__content" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ ref: this.contentRef }, { children: this.props.isDynamicallyLoaded ? ((0, jsx_runtime_1.jsx)(react_animate_height_1.default, __assign({ height: isOpen ? "auto" : 0, duration: 400, animateOpacity: true }, { children: isOpen && children }))) : ((0, jsx_runtime_1.jsx)(react_animate_height_1.default, __assign({ height: isOpen ? "auto" : 0, duration: 400, animateOpacity: true }, { children: children }))) })) })));
    };
    return AccordionCollapse;
}(React.Component));
exports.AccordionCollapse = AccordionCollapse;
